<template>
<div class="chapter">
<div class="inner_page">
<h1>Liavek, year 3317</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?cb632eba